import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { SlackBlocksModule } from '../slack-blocks/slack-blocks.module';
import { UnlayerWrapperComponent } from '../unlayer-wrapper/unlayer-wrapper.component';

import { TemplateOptionsPage } from './template-options/template-options.page';
import { TemplatesComponent } from './templates.component';

@NgModule({
  imports: [CommonModule, IonicModule, FormsModule, UnlayerWrapperComponent, SlackBlocksModule],
  declarations: [TemplatesComponent, TemplateOptionsPage],
  exports: [TemplatesComponent, TemplateOptionsPage],
})
export class TemplatesModule {}
